/**
 * JWT token storage — thin wrapper around localStorage.
 *
 * Centralises every read/write so token handling stays consistent
 * across AuthContext, apiFetch, and the WebSocket client.
 */

const TOKEN_KEY = 'launcher_jwt';

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    console.warn('[tokenStore] Unable to persist token to localStorage');
  }
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}

export function isAuthenticated() {
  return !!getToken();
}
